var NCSK = NCSK || {};

NCSK.gridBackground = new function () {

    this.init = function () {
        setBackgroundImage();
    }

    // Shrink menu on scroll
    function setBackgroundImage() {
        $('[data-background-image]').each(function (b, a) {
            $(a).css("background-image", 'url(' + $(a).data('background-image') + '?width=1920&format=jpeg&quality=75)');
            $(a).removeAttr('data-background-image');
        });
    }

};

